var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-text-field',{ref:"text",attrs:{"type":"number","value":_vm.value,"label":_vm.name,"error-messages":_vm.errorMessages},on:{"input":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }